import createIcon from '../../createIcon';

/**
 * @component @name Foundation
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgMTIuNUgyMkwxMiAzLjVMMiAxMi41SDVWMTUuNUgzVjE3LjVINVYyMC41SDdWMTcuNUgxMVYyMC41SDEzVjE3LjVIMTdWMjAuNUgxOVYxNy41SDIxVjE1LjVIMTlWMTIuNVpNNyAxNS41VjEwLjY5TDExIDcuMDlWMTUuNUg3Wk0xMyAxNS41VjcuMDlMMTcgMTAuNjlWMTUuNUgxM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Foundation = createIcon('Foundation', [
  [
    'path',
    {
      d: 'M19 12.5H22L12 3.5L2 12.5H5V15.5H3V17.5H5V20.5H7V17.5H11V20.5H13V17.5H17V20.5H19V17.5H21V15.5H19V12.5ZM7 15.5V10.69L11 7.09V15.5H7ZM13 15.5V7.09L17 10.69V15.5H13Z',
      key: '4zvbvy',
    },
  ],
]);

export default Foundation;
